import { createApiActions } from '../../../utils/api-state';
import { OptInGetRes, OptInUpdateReq } from '../models/opt-in.model';
import { createAction, props } from '@ngrx/store';

export const getOptInActions = createApiActions<null, OptInGetRes>(`[Opt in] Get`);
export const updateOptInSuccess = createAction('[Opt in] Update Success', props<{ response: OptInUpdateReq }>());
